export default {
    getHanasysExpert: state => {
        return state.hanasysExpert
    },
    getEnterpriseVesselsWithContainers: state => {
        return state.enterpriseVesselsWithContainers
    }
}
